import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from '@/components/Icons/ArrowLeft';
import { Close } from '@/components/Icons/Close';

interface Props {
  title: string;
  isMobileTitleHidden?: boolean;
  onClose: () => void;
  onBack?: () => void;
}

export const ModalHeader: React.FC<Props> = ({
  title,
  isMobileTitleHidden = false,
  onClose,
  onBack,
}) => {
  const { t } = useTranslation();

  return (
    <header className="flex shrink-0 items-center gap-3 px-4 pt-[calc(16px+env(safe-area-inset-top))] pb-3 md:px-5 md:pt-5 md:pb-4">
      <button
        type="button"
        aria-label={t('global.back')}
        onClick={onBack ?? onClose}
        className={`flex size-6 shrink-0 cursor-pointer items-center justify-center text-foreground ${onBack ? '' : 'md:hidden'}`}
      >
        <ArrowLeft />
      </button>

      <h2
        className={`text-callout-16 md:text-headline-20 min-w-0 flex-1 truncate text-foreground transition-opacity duration-150 max-md:text-center ${isMobileTitleHidden ? 'max-md:opacity-0' : ''}`}
      >
        {title}
      </h2>

      <span className="size-6 shrink-0 md:hidden" />

      <button
        type="button"
        aria-label={t('global.close')}
        onClick={onClose}
        className="hidden size-4 shrink-0 cursor-pointer items-center justify-center text-foreground md:flex"
      >
        <Close className="size-4" />
      </button>
    </header>
  );
};
